import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/home'

export default withAuthUser({})(Page.Home)
